import React, { useEffect } from 'react';
import { Box, Typography } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

function AkademyWidgetCustomization() {
  const dispatch = useDispatch();

  const { school, widgetConfig } = useSelector(({ akademyReducer }) => {
    return {
      school: akademyReducer.school,
      widgetConfig: akademyReducer.widgetConfig,
    };
  });

  return (
    <Box>
      <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
        {/* <Button onClick={() => {}} variant={'contained'} color="primary">
          Widget Setup : {schoolId}
        </Button> */}
        <Box>
          <Typography variant="h6">Widget Customization</Typography>
        </Box>
      </Box>

      <Typography variant="subtitle1" color="textSecondary">
        Coming Soon...
      </Typography>
    </Box>
  );
}

export default AkademyWidgetCustomization;
